// import React from "react";
// import "./loading.css";

// const Loading = ({ loadingState }) => {
//   return (
//     loadingState?.loading && (
//       <div className="overlay">
//         <div className="spinner"></div>
//       </div>
//     )
//   );
// };
// export default Loading;

import React from "react";
import "./loading.css";

const Loading = ({ loadingState }) => {
  return (
    loadingState?.loading && (
      // <div className="overlay">
      //   <div className="spinner"></div>
      // </div>
      <>
        <div id="infoModal1" className="overlay">
          <div className="loading-box">
            <div className="lds-roller">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="loading lds-roller">Loading...</div>
          </div></div>
      </>
    )
  );
};
export default Loading;

// import React from 'react'

// const LoadingSpinner = () => {
//     return (
//         <div className="loading-box" style={{ backgroundColor: "#ffffff" }}>
//             <div className="lds-roller">
//                 <div></div>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//                 <div></div>
//             </div>
//             <div className="loading lds-roller">Loading...</div>
//         </div>
//     )
// }

// export default LoadingSpinner